import { FC } from 'react'

import AdministrationMenu from './components/AdministrationMenu'
import LogoutMenu from './components/LogoutMenu'
import MySettingsMenu from './components/MySettingsMenu'

const PageHeaderSettingsPopupContent: FC = () => {
  return (
    <div>
      <MySettingsMenu />
      <AdministrationMenu />
      <LogoutMenu />
    </div>
  )
}

export default PageHeaderSettingsPopupContent
